import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AppContainer from "./containers/appContainer";
import { listener } from "@utils";

window.addEventListener("message", (event) => {
  listener(event);
});

const Raiz =
  process.env.NODE_ENV === "development" &&
  new URLSearchParams(window.location.search).has("teste-enquadramento")
    ? require("./components/teste-enquadramento").default
    : AppContainer;

ReactDOM.render(<Raiz />, document.getElementById("root"));
